export const Shorts = [
    {
        "id": 32,
        "Title": "IES-2024-32",
        "ImageSource": "/Boxing/boxing shorts/1.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 33,
        "Title": "IES-2024-33",
        "ImageSource": "/Boxing/boxing shorts/2.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 34,
        "Title": "IES-2024-34",
        "ImageSource": "/Boxing/boxing shorts/3.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 35,
        "Title": "IES-2024-35",
        "ImageSource": "/Boxing/boxing shorts/4.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 36,
        "Title": "IES-2024-36",
        "ImageSource": "/Boxing/boxing shorts/5.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 37,
        "Title": "IES-2024-37",
        "ImageSource": "/Boxing/boxing shorts/6.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 38,
        "Title": "IES-2024-38",
        "ImageSource": "/Boxing/boxing shorts/7.jpg",
        "Category": "Boxing Shorts"
    },
    {
        "id": 39,
        "Title": "IES-2024-39",
        "ImageSource": "/Boxing/boxing shorts/8.jpg",
        "Category": "Boxing Shorts"
    }
];
